<template>
  <div v-loading="loading" class="card">
    <div class="title">设备记录</div>
    <el-row class="tool-row" align="middle">
      <el-col :span="3"> 设备 </el-col>
      <el-col :span="6">
        <el-select
          v-model="categorySelect"
          multiple
          clearable
          collapse-tags
          collapse-tags-tooltip
          placeholder="全部"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in sensorsList"
            :key="index"
            :value="item"
          /> </el-select
      ></el-col>
    </el-row>
    <el-row class="tool-row" align="middle" style="margin-top: 0">
      <el-col :span="3"> 时间选择 </el-col>
      <el-col :span="14">
        <el-date-picker
          v-model="timeSelect"
          type="datetimerange"
          unlink-panels
          range-separator="到"
          start-placeholder="起始时间"
          end-placeholder="截止时间"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-col>
      <el-col :span="2">
        <el-button @click="select" type="primary">选择</el-button>
      </el-col>
    </el-row>
    <el-table class="table" :data="dataList" :border="true">
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
        :index="indexMethod"
      />
      <el-table-column prop="dateTime" label="时间" width="280" />
      <el-table-column prop="name" label="设备名" />
      <el-table-column
        prop="operation"
        label="操作"
        width="100"
      />
    </el-table>
    <el-row class="tool-row" align="middle" style="height: 50px; margin-top: 0">
      <el-col :span="2">
          <el-button @click="output" type="primary">导出</el-button>
      </el-col>
      <el-col :span="14" :offset="8">
        <el-pagination
          class="pagination"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalNumber"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { useBarnStore } from "@/stores/barn";
import { queryEquipmentDataAPI } from "@/apis/dataAPI";
import { querySensorNameListAPI } from "@/apis/sensorAPI";
import * as category from "@/constant/data-category";
import Download from "@/utils/export"
import { onMounted, ref, watch } from "vue";

//获取畜舍id
const barnStore = useBarnStore();

//表格页码相关
const totalNumber = ref(10);
const pageSize = ref(10);
const currentPage = ref(1);
const handleCurrentChange = (val) => {
  currentPage.value = val;
  queryEquipmentData();
};
//重构表格序号
const indexMethod = (index) =>
  index + (currentPage.value - 1) * pageSize.value + 1;

//参数相关
const categorySelect = ref([]);
const timeSelect = ref([]);
const selectClear = () => {
  (categorySelect.value = []), (timeSelect.value = []);
};

//等待加载
const loading = ref(false)

//接收数据
const sensorsList = ref([]);
const dataList = ref([]);
const rawData = ref([]);
let barnId = 1;
let barnName = ""
let name = "";
let begin = "";
let end = "";

//参数相关
const querySensorNameList = async () => {
  const { data } = await querySensorNameListAPI({
    barnId: barnStore.barnId,
    sensorClass: category.EQUIPMENT_SENSOR,
  });
  sensorsList.value = data;
};
const queryEquipmentData = async () => {
  loading.value = true
  barnId = barnStore.barnId;
  barnName = barnStore.barnName;
  begin = timeSelect.value==null? undefined:timeSelect.value[0];
  end = timeSelect.value==null? undefined:timeSelect.value[1];
  name = categorySelect.value.toString();
  const { data } = await queryEquipmentDataAPI({
    barnId: barnId,
    pageNo: currentPage.value,
    pageSize: pageSize.value,
    name: name,
    begin: begin,
    end: end,
  });
  totalNumber.value = data.total;
  dataList.value = data.list;
  loading.value = false;
};

const queryRawData = async()=>{
  const {data} = await queryEquipmentDataAPI({
    barnId: barnId,
    pageSize: 0,
    name: name,
    begin: begin,
    end: end,
  })
  rawData.value = data.list
}


//数据初始化
querySensorNameList();
queryEquipmentData();

//选择按钮函数
const select = () => {
  currentPage.value = 1
  queryEquipmentData();
};
const output = async () => {
  await queryRawData();
  Download(rawData.value, barnName + "—设备记录");
};


onMounted(() => {
  watch(
    () => barnStore.barnId,
    () => {
      selectClear();
      queryEquipmentData();
      querySensorNameList();
    }
  );
});
</script>

<style scoped lang="less">
.card {
  width: 100%;
  min-height: 550px;
  background-color: white;
  .title {
    font-family: @title;
    font-weight: bold;
    font-size: 22px;
    height: 30px;
    line-height: 30px;
    padding-top: 20px;
    padding-left: 35px;
  }
  .tool-row {
    width: 850px;
    height: 50px;
    left: 35px;
    margin-top: 15px;
    font-size: 16px;
  }
  .table {
    width: 850px;
    height: 440px;
    left: 50%;
    transform: translateX(-50%);
    font-family: @text;
    color: black;
  }
  .pagination {
    position: relative;
    float: right;
  }
}
</style>